import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { rentVariantColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import type { ApiRentVariant } from '@Model';
import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { RentVariantsRepository } from '@Repositories/Stammdaten';

// @ai-generated 2026-10-21T10:02:26+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)

export function FrameListRentVariant() {
    const hasPermission = useHasPermission();

    const module = useListApi(RentVariantsRepository, STAMMDATEN_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiRentVariant>
            layoutSettingsContext={EnumFrontendLayoutSetting.RentVariantsTableLayout}
            name="RentVariantList"
            columns={rentVariantColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.StammdatenRentVariantCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
